export const ADD_TODO = 'ADD_TODO';
export const ADD_EMPTY_TODO = 'ADD_EMPTY_TODO';
export const EDIT_TODO = 'EDIT_TODO';
export const REMOVE_TODO = 'REMOVE_TODO';
export const SET_FILTER = 'SET_FILTER'
export const REMOVE_EMPTY_TODO = 'REMOVE_EMPTY_TODO';
export const ALTER_TODO_CONTAINER = 'ALTER_TODO_CONTAINER';
export const ALTER_TODO_POSITION = 'ALTER_TODO_POSITION';
export const ADD_CONTAINER = 'ADD_CONTAINER';
export const EDIT_CONTAINER = 'EDIT_CONTAINER'
export const REMOVE_CONTAINER = 'REMOVE_CONTAINER';
export const ALTER_CONTAINER_POSITION = 'ALTER_CONTAINER_POSITION';
export const MANAGE_TODO_FORM = 'MANAGE_TODO_FORM';
export const SET_ACTIVE_TODO = 'SET_ACTIVE_TODO';
export const SET_ACTIVE_CONTAINER = 'SET_ACTIVE_CONTAINER';
export const SET_DRAG_CONTAINER = 'SET_DRAG_CONTAINER';
export const SET_TAGS = 'SET_TAGS';
export const SET_DARK_MODE = 'SET_DARK_MODE';
